export const PRODUCT_CATEGORIES = {
  fixture: 'Lighting Fixture',
  control: 'Lighting Control',
  speaker: 'Speaker',
  camera: 'Camera',
  amplifier: 'Amplifier',
  processor: 'Processor',
  display: 'Display',
  touch_panel: 'Touch Panel',
  access_point: 'Access Point',
  switch: 'Network Switch',
  sensor: 'Sensor',
  doorbell: 'Doorbell',
  group: 'Group/Rack',
  other: 'Other'
} as const;

export const AV_CATEGORIES = [
  'speaker',
  'camera',
  'amplifier',
  'processor',
  'display',
  'touch_panel',
  'access_point',
  'switch',
  'sensor',
  'doorbell',
  'other'
] as const;

export const LIGHTING_CATEGORIES = [
  'fixture',
  'control'
] as const;

export type ProductCategory = keyof typeof PRODUCT_CATEGORIES;